<template >
  <div class="top">
    <div class="welcome">
      <CRow>
      <CCol sm="6">
      <h5 class="display-5">Grade</h5>
      <h6 class="display-6">
        Your daily quiz is wating for you, but first please select your grade
        level.
      </h6>
      </CCol>
      </CRow>
<br /><br />
      <CCard>
        <CCol sm="12" class="justify-content-center mb-4 mt-3">
           <CRow>
          <CCol
           v-for="item in grades" v-bind:key="item.Id"
            class="justify-content-center"
            sm="3"
          >
            <br />
            
            <CRow
              id="sb"
              style="border-radius: 10px;border:2px solid #eee"
              class="m-0 pt-1 col-12"
              @click="GotoPageSubject(item.Id)"
            >
              
              <CCol class="col-12 text-left mt-3 mb-3 p-0">
                <h6 class="ml-2 mr-2 text-black custom-font">
                   <h6 class="custom-font"><img style="max-width:50px" src="../assets/img/banners.png" class="mr-2"/>{{ item.GradeName }}</h6>
                </h6>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
        </CCol>
      </CCard>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundBanner from "../assets/img/bgApps.jpg";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

import Mainlayout from "../containers/TheHeaderStudentCustom.vue";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "QuizStudentDashboard",
  components: {
    PulseLoader,
    Mainlayout,
  },
  data() {
    return {
      backgroundBanner,
      grades: [],
      StudentProfile: {},
      user: {},
    };
  },
  async mounted() {
    this.SessionUserIdNo();
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetStudentProfile();
      this.GetGradeList();
    } else {
      this.GoToLogin();
    }
  },

  methods: {
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetStudentProfile(this.user.id);
          }
        });
    },
    async GetStudentProfile() {
      this.$API
        .get(this.$StudentProfile + "?studentId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.StudentProfile = response.data;
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    GetGradeList() {
      this.$API
        .get(this.$QuizGradeList, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.grades = response.data;
            console.log(this.grades);
          }
        });
    },
    GotoPageSubject(gradeId) {
      this.$router.push(
        "/QuizSubject?userId=" +
          this.user.id +
          "&studentId=" +
          this.$route.query.studentId +
          "&gradeId=" +
          gradeId
      );
    },
  },
};
</script>

<style>
.float-child {
  width: 100%;
  padding: 15px;
  height: 500px;
  border: 2px solid red;
  border-style: outset;
  background-color: white;
}
.float-container {
  border: 2px solid orange;
  width: 100%;
}

.menu {
  border: 3px solid lightgreen;
}

.button {
  background-color: #008b8b;
  color: white;
  padding: 5px 5px 5px 70px;
  text-align: right;
  display: block;
  font-size: 15px;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 12px;
}
.button1 {
  background-color: rgb(109, 41, 138);
  color: white;
  padding: 1px 5px 1px 5px;
  text-align: right;
  text-decoration: none;
  display: block;
  font-size: 15px;
  margin: 2px 1px;
  cursor: pointer;
  border-radius: 15px;
}

.button2 {
  background-color: rgb(109, 41, 138);
  color: white;
  padding: 1px 5px 1px 15px;
  text-align: right;
  text-decoration: none;
  display: block;
  font-size: 15px;
  margin: 2px 1px;
  cursor: pointer;
  border-radius: 15px;
}

.button3 {
  background-color: rgb(109, 41, 138);
  color: white;
  padding: 1px 5px 1px 25px;
  text-align: right;
  text-decoration: none;
  display: block;
  font-size: 15px;
  margin: 2px 1px;
  cursor: pointer;
  border-radius: 15px;
}

.button4 {
  background-color: rgb(109, 41, 138);
  color: white;
  padding: 1px 5px 1px 35px;
  text-align: right;
  text-decoration: none;
  display: block;
  font-size: 15px;
  margin: 2px 1px;
  cursor: pointer;
  border-radius: 15px;
}

.button5 {
  background-color: rgb(109, 41, 138);
  color: white;
  padding: 1px 5px 1px 45px;
  text-align: right;
  text-decoration: none;
  display: block;
  font-size: 15px;
  margin: 2px 1px;
  cursor: pointer;
  border-radius: 15px;
}

.button6 {
  background-color: rgb(109, 41, 138);
  color: white;
  padding: 1px 5px 1px 55px;
  text-align: right;
  text-decoration: none;
  display: block;
  font-size: 15px;
  margin: 2px 1px;
  cursor: pointer;
  border-radius: 15px;
}

.button7 {
  background-color: #008b8b;
  color: white;
  padding: 1px 5px 1px 65px;
  text-align: right;
  display: block;
  font-size: 15px;
  margin: 2px 1px;
  cursor: pointer;
  border-radius: 12px;
}

.button8 {
  background-color: #008b8b;
  color: white;
  padding: 1px 5px 1px 75px;
  text-align: right;
  display: block;
  font-size: 15px;
  margin: 2px 1px;
  cursor: pointer;
  border-radius: 12px;
}

.button9 {
  background-color: #008b8b;
  color: white;
  padding: 1px 5px 1px 85px;
  text-align: right;
  display: block;
  font-size: 15px;
  margin: 2px 1px;
  cursor: pointer;
  border-radius: 12px;
}

.button10 {
  background-color: #008b8b;
  color: white;
  padding: 1px 5px 1px 95px;
  text-align: right;
  display: block;
  font-size: 15px;
  margin: 2px 1px;
  cursor: pointer;
  border-radius: 12px;
}

.button11 {
  background-color: #008b8b;
  color: white;
  padding: 1px 5px 1px 105px;
  text-align: right;
  display: block;
  font-size: 15px;
  margin: 2px 1px;
  cursor: pointer;
  border-radius: 12px;
}

#main {
  width: 100%;
  height: 80px;
  border: 1px solid #941515;
  display: flex;
  justify-content: center;
}

#main div {
  width: 210px;
  height: 0px;
}
</style> 